var map = {
	"./ausgewaehlte_produkte.svg": 511,
	"./ausgewaehlte_qualitaet.svg": 512,
	"./bambus.svg": 513,
	"./bestseller.svg": 514,
	"./bio_baumwolle.svg": 515,
	"./geschenkideen.svg": 516,
	"./handmade.svg": 517,
	"./made_in_eu.svg": 518,
	"./mit_liebe_verpackt.svg": 519,
	"./nachhaltigkeit.svg": 520,
	"./packed_with_love.svg": 521,
	"./personalisierung.svg": 522,
	"./rechnung.svg": 523,
	"./schnelle_lieferung.svg": 524,
	"./sichere_zahlung.svg": 525,
	"./verfuegbar.svg": 526,
	"./widerrufsrecht.svg": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;